// AIVIO unread: sidebar unread counts (upstream f33e469e9 + 4d3196b02).
// AIVIO deviations:
//  - `pending: true` from the backend (cache is being built) keeps the current
//    badges and retries once after PENDING_RETRY_MS;
//  - 403 (feature switched off for the account) clears the badges.
import ConversationAPI from '../../api/conversations';
import types from '../mutation-types';

const PENDING_RETRY_MS = 5000;
let pendingRetryTimer = null;

export const state = {
  allCount: 0,
  inboxes: {},
  labels: {},
  teams: {},
};

const normalizeCount = count => {
  const parsedCount = Number(count);
  return Number.isFinite(parsedCount) && parsedCount > 0 ? parsedCount : 0;
};

const normalizeCounts = counts => {
  return Object.entries(counts || {}).reduce((result, [id, count]) => {
    const parsedCount = normalizeCount(count);
    if (parsedCount > 0) {
      result[String(id)] = parsedCount;
    }

    return result;
  }, {});
};

const clearPendingRetry = () => {
  if (!pendingRetryTimer) return;
  clearTimeout(pendingRetryTimer);
  pendingRetryTimer = null;
};

export const getters = {
  getAllUnreadCount($state) {
    return $state.allCount;
  },
  getInboxUnreadCount: $state => inboxId => {
    return $state.inboxes[String(inboxId)] || 0;
  },
  getLabelUnreadCount: $state => labelId => {
    return $state.labels[String(labelId)] || 0;
  },
  getTeamUnreadCount: $state => teamId => {
    return $state.teams[String(teamId)] || 0;
  },
  getInboxUnreadCounts($state) {
    return $state.inboxes;
  },
  getLabelUnreadCounts($state) {
    return $state.labels;
  },
  getTeamUnreadCounts($state) {
    return $state.teams;
  },
};

export const actions = {
  get: async function getUnreadCounts({ commit, dispatch }) {
    try {
      const response = await ConversationAPI.getUnreadCounts();
      const payload = response.data?.payload || {};
      if (payload.pending) {
        if (!pendingRetryTimer) {
          pendingRetryTimer = setTimeout(() => {
            pendingRetryTimer = null;
            dispatch('get');
          }, PENDING_RETRY_MS);
        }
        return;
      }
      clearPendingRetry();
      commit(types.SET_CONVERSATION_UNREAD_COUNTS, payload);
    } catch (error) {
      // Ignore errors so the sidebar can continue rendering; 403 = switched off.
      if (error?.response?.status === 403) {
        clearPendingRetry();
        commit(types.SET_CONVERSATION_UNREAD_COUNTS, {});
      }
    }
  },
  clear({ commit }) {
    clearPendingRetry();
    commit(types.SET_CONVERSATION_UNREAD_COUNTS, {});
  },
};

export const mutations = {
  [types.SET_CONVERSATION_UNREAD_COUNTS]($state, payload = {}) {
    $state.allCount = normalizeCount(payload.all_count);
    $state.inboxes = normalizeCounts(payload.inboxes);
    $state.labels = normalizeCounts(payload.labels);
    $state.teams = normalizeCounts(payload.teams);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
